<template>
  <div class="x-tablelist-view" data-automation="manageProduct">
    <div class="search-warp">
      <add-imei-input v-model="filter.deviceImeis" :showAdd="false"></add-imei-input>
      <ux-select v-model="filter.vendor" clearable :options="vendorList" :props="{ label: 'name', value: 'name' }"
        :placeholder="$t('HT.pleaseSelect') + $t('HT.advancedService.vendor')"></ux-select>
      <ux-select v-model="filter.mcType" clearable :options="allMctype" :props="{ label: 'name', value: 'name' }"
        :placeholder="$t('HT.upgrade.mctype')"></ux-select>

      <ux-date v-model="filter.date" daterange time></ux-date>

      <el-button type="primary" @click="seach" size="small">{{
        $t('HT.search')
      }}</el-button>
      <el-button plain @click="reset" size="small">{{
        $t('HT.reset')
      }}</el-button>
    </div>


    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table ref="table" :showPage="showPage" maxHeight="100%" :hide-on-single-page="true" :data="tableData.list"
        :columns="columns" :total="tableData.totalSize" :size.sync="filter.size" :page.sync="filter.page"
        @changePage="changePage" @changeSize="changeSize" :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"></ux-table>
    </div>
  </div>
</template>

<script lang="jsx">
import AddImeiInput from '@/components/AddImeiInput/index.vue';
import { strategyStatusFilter } from '@/filters';
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    AddImeiInput
  },
  data() {
    return {
      vendorList: [],
      userData: {}, // 登录者信息
      showPage: true,
      columns: [
        // 表头数据
        {
          label: this.$t('HT.applyInfo.createTime'),
          tooltip: true,
          align: 'left',
          prop: 'time',
        },
        {
          label: this.$t('HT.label.imei'),
          prop: 'deviceImei',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.positionType.mctype'),
          prop: 'mcType',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.serviceName'),
          prop: 'serviceName',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.advancedService.vendor'),
          prop: 'vendor',
          align: 'left',
          tooltip: true,
        },

        {
          label: this.$t('HT.label.locationType'),
          prop: 'locationType',
          align: 'left',
          tooltip: true,
          render: (h, data) => <span class="form-val">{this.$opt.switchStr(data.locationType, this.$opt.positionType)}</span>
        },
        {
          label: this.$t('HT.advancedService.requestParams'),
          prop: 'param',
          align: 'left',
          tooltip: true,
        },
        {
          label: this.$t('HT.generateApi.title'),
          prop: 'result',
          align: 'left',
          tooltip: true,
        },

        {
          label: this.$t('HT.advancedService.requestData'),
          prop: 'status',
          align: 'left',
          tooltip: true,
          render: (h, data) => <span class="form-val" style={{ color: ['#F45C5C', '#3DC456'][data.status] }}>{data.status === 1 ? '成功' : '失败'}</span>
        },
      ],
      filter: {
        // 查询参数
        serviceType: 'LBS',
        deviceImeis: '',
        vendor: '',
        mcType: '',
        date: [],
        startTime: '',
        endTime: '',
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    this.getPlatform();
    this.getAllList();
    this.getAllMctype()
    this.getAllServiceVendor()
    this.userData = this.$store.state.login.userData;
  },
  computed: {
    ...mapState('advancedService', ['platform', 'allMctype'])
  },
  methods: {
    ...mapActions('advancedService', ['getPlatform', 'getAllMctype']),
    async getAllServiceVendor() {
      let { code, data } = await this.$api.advancedService.getAllServiceVendor();
      code === 10000 && (this.vendorList = data);
    },

    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getAllList() {
      const [startTime, endTime] = this.filter.date || [];
      const params = Object.assign({}, this.filter, { startTime, endTime });
      this.$uxLoading.show();
      this.$api.advancedService.recordLog(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },


    /**
     * 搜索
     */
    seach() {
      this.filter.page = 1;
      this.getAllList();
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getAllList();
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getAllList();
    },
    reset() {
      this.filter.deviceImeis = '';
      this.filter.vendor = '';
      this.filter.mcType = '';
      this.filter.startTime = '';
      this.filter.endTime = '';
      this.filter.date = [];
      this.filter.page = 1;
      this.filter.size = 10;
      this.getAllList();
    },
    goToDetail(params) {
      this.$router.push({ path: '/advancedService/detail', query: { id: params.strategyId } });
    },

  }
};
</script>
<style lang="scss" scoped>
.search-warp {
  display: flex;

  >div {
    width: auto !important;
    margin-right: 10px;
    display: inline-block;
  }
}

.ux-search-option {
  z-index: 10;
}
</style>